import { Sunrise } from "lucide-react";
import { DAILY_LINE_STATES, DAILY_LINE_ACTION_KEYS, dailyLineAction, dailyLineCopy } from "../dailyLineSetting.js";
import { t } from "../strings.js";

// IT #179 — **THE PANEL SHE READS AND THE ONE CONTROL SHE TAPS.**
//
// Hookless (R7/R8's entry requirement), so `scripts/it179-daily-line-setting.mjs` CALLS it once per
// state and reads the tree back. The state and the round trip live in `DailyLineSetting.tsx`, which
// is `PushSettings`/`PushSettingsPanel`'s split one preference over — and for the same reason: the
// door this house was missing was missing because nothing could see it.
//
// **THE SECOND LINE IS THE WHOLE POINT OF THIS CONTROL EXISTING.** It says this governs ONLY the
// morning reading, because a member who turns this off and later stops hearing that someone
// messaged her must not conclude that this switch did it — the confusion the notifications door
// caused sshinetha in the first place, inverted.
export function DailyLineSettingPanel({
  state, busy = false, note = "", language = "en", onAct,
}: {
  state: string;
  busy?: boolean;
  note?: string;
  language?: string;
  onAct: (action: string) => void;
}) {
  const action = dailyLineAction(state);
  return (
    <div className={`push-settings daily-setting daily-setting--${state}`}>
      <h3 className="push-settings__head">
        <Sunrise size={15} aria-hidden="true" />
        {" "}{t(language, "daily.setting.heading")}
      </h3>
      <p className="push-settings__state">{t(language, dailyLineCopy(state))}</p>
      {/* Drawn on both real states and NOT while the setting is still unknown: a scope note beside a
          state nobody has read yet is reassurance about something that has not been said (R18). */}
      {state === DAILY_LINE_STATES.UNKNOWN ? null : (
        <p className="push-settings__note">{t(language, "daily.setting.note")}</p>
      )}
      {action ? (
        <button
          type="button"
          className={`push-settings__act daily-setting__act--${action}`}
          onClick={() => onAct(action)}
          disabled={busy}
        >
          {busy ? t(language, "daily.setting.working") : t(language, DAILY_LINE_ACTION_KEYS[action])}
        </button>
      ) : null}
      {/* R47/R53/R61: the answer is READ and a refusal is SAID. A control that swallows its own
          failure leaves a truthful-looking screen, which is the one shape nobody reports. */}
      {note ? <p className="push-settings__note push-settings__note--warn">{note}</p> : null}
    </div>
  );
}
